import { render, staticRenderFns } from "./CouponGroupsCouponCreate.vue?vue&type=template&id=0c74f6ca&scoped=true"
import script from "./CouponGroupsCouponCreate.vue?vue&type=script&lang=ts"
export * from "./CouponGroupsCouponCreate.vue?vue&type=script&lang=ts"
import style0 from "./CouponGroupsCouponCreate.vue?vue&type=style&index=0&id=0c74f6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74f6ca",
  null
  
)

export default component.exports